import React, { useEffect } from "react";

import NextLink from "next/link";
import { useRouter } from "next/router";

import { Box, Button, Drawer, IconButton, Link } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

import PropTypes from "prop-types";

import Logo from "../Logo";

const MainSidebarLink = styled(Link)(({ theme }) => ({
  display: "block",
  padding: theme.spacing(1.5),
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const MainSidebar = ({ onClose, open }) => {
  const router = useRouter();
  const handlePathChange = () => {
    if (open) {
      onClose?.();
    }
  };
  useEffect(
    handlePathChange,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router?.asPath]
  );
  return (
    <Drawer
      anchor="right"
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 300 } }}
      sx={{
        zIndex: (theme) => theme.zIndex.appBar + 100,
      }}
      variant="temporary"
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ width: "100%", textAlign: "end", pb: 2 }}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Logo sx={{ width: "100%", textAlign: "center" }} />
        <NextLink href="/business" passHref>
          <MainSidebarLink color="textSecondary" underline="none">
            商業委託
          </MainSidebarLink>
        </NextLink>
        <NextLink href="/creator" passHref>
          <MainSidebarLink color="textSecondary" underline="none">
            成為創作者
          </MainSidebarLink>
        </NextLink>
        <NextLink href="/contact" passHref>
          <MainSidebarLink color="textSecondary" underline="none">
            聯絡我們
          </MainSidebarLink>
        </NextLink>
        <NextLink href="/business" passHref>
          <MainSidebarLink color="textSecondary" underline="none">
            回到主頁
          </MainSidebarLink>
        </NextLink>
        <NextLink
          href={
            process.env.NODE_ENV === "production"
              ? "https://www.flyingmilktea.com"
              : "#"
          }
          passHref
        >
          <MainSidebarLink color="textSecondary" underline="none">
            飛天奶茶主頁
          </MainSidebarLink>
        </NextLink>
        <NextLink
          href={
            process.env.NODE_ENV === "production"
              ? "https://market.flyingmilktea.com"
              : "#"
          }
          passHref
        >
          <MainSidebarLink color="textSecondary" underline="none">
            飛天奶茶未來墟
          </MainSidebarLink>
        </NextLink>
        <Button
          href="/business/contact-sales"
          fullWidth
          sx={{ mt: 1.5 }}
          variant="contained"
        >
          立即開始委託
        </Button>
        <Button
          href="/creator/join-us"
          fullWidth
          sx={{ mt: 1.5 }}
          variant="contained"
        >
          創作者申請
        </Button>
      </Box>
    </Drawer>
  );
};

MainSidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default MainSidebar;
